import { apiServiceWrapper } from '../../../../Middleware/API/apiRequest';
import { getTokensFromStorage } from '../../../../Utils/Auth/AuthToken';
import {
  APPLICATION_KEY,
  APPLICATION_USER,
} from '../../../../constants/apiRoutes';
import {
  getGraphqlCacheResponse,
  setGraphqlCacheResponse,
} from '../../../../Utils/Storage/IndexDB/indexDbWrappers';
/**
 * get UserDetail Profile.
 * @returns {Promise} - A promise that resolves with get UserDetail Profile or rejects with an error.
 * @param props
 */
export const getUserProfile = async ({
  accessToken,
  moduleName,
  isServiceWorker,
  listController,
  user,
}) => {
  const response = await apiServiceWrapper({
    url: `${APPLICATION_USER}/TenantUser/${user?.userId}`,
    method: 'GET',
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
  });
  if (response?.isError) {
    if (isServiceWorker) {
      let cacheResponse = await getGraphqlCacheResponse(
        headers,
        isServiceWorker,
      );
      return cacheResponse;
    }
    return response;
  }
  if (isServiceWorker) {
    await setGraphqlCacheResponse(headers, response, isServiceWorker);
  }
  return {
    data: response.Payload,
    TotalCount: response?.TotalRecordCount,
  };
};

/**
 * Update UserDetail Profile
 * @returns {Promise} - A promise that resolves with the list of Tests or rejects with an error.
 * @param props
 */
export const updateUserProfile = async ({
  data,
  accessToken,
  moduleName,
  isServiceWorker,
  listController,
  user,
}) => {
  const response = await apiServiceWrapper({
    url: `${APPLICATION_USER}/${user?.userId}`,
    body: data,
    method: 'PUT',
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
  });
  return response;
};

/**
 * susbcribe feature.
 * @returns {Promise} - A promise that resolves with the list of users or rejects with an error.
 * @param props
 */
export const createAppKey = async () => {
  const { accessToken } = getTokensFromStorage();
  const data = {};
  const response = await apiServiceWrapper({
    url: `${APPLICATION_KEY}`,
    body: data,
    method: 'POST',
    accessToken,
  });
  return response;
};
